/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { PAMMState } from '../../../redux/reducers/rootReducer';
import englishIcon from '../../../icons/English.svg';
import deutschIcon from '../../../icons/Deutsch.svg';
import frenchIcon from '../../../icons/French.svg';
import portugalIcon from '../../../icons/Portugal.svg';
import spanishIcon from '../../../icons/Spanish.svg';
import arabianIcon from '../../../icons/Arabian.svg';
import japanIcon from '../../../icons/Japan.svg';
import koreanIcon from '../../../icons/Korean.svg';
import chineseIcon from '../../../icons/Chinese.svg';
import style from './LanguagesMenuMobile.module.css';
import { applyStyles } from '../../../utils/applyStyles';
import LocalStorageUtils from '../../../utils/local-storage';

const LanguagesMenuMobile: React.FC<any> = ({ onSwipe, menuHeight, onCancel, onLangChange }): JSX.Element => {
  const languages: Record<string, string> = useSelector((state: PAMMState) => state.configReducer.languages);
  const show = useSelector((state: PAMMState) => state.mobileMenusStatusReducer.showLanguagesMenu);

  const defaultLanguage: string = useSelector((state: PAMMState) => state.configReducer.defaultLanguage);
  const [currentLang, setLang] = useState<string>(
    (LocalStorageUtils.getValueFromLocalStorage('lang') as string) || defaultLanguage
  );

  useEffect(() => {
    setLang(LocalStorageUtils.getValueFromLocalStorage('lang')!);
  });

  const getLanguagesFlags = (value: any): string => {
    switch (value) {
      case 'English':
        return englishIcon;
      case 'Deutsch':
        return deutschIcon;
      case 'Français':
        return frenchIcon;
      case 'Português':
        return portugalIcon;
      case 'Español':
        return spanishIcon;
      case 'العربية':
        return arabianIcon;
      case '한국어':
        return koreanIcon;
      case '日本語':
        return japanIcon;
      case '中文':
        return chineseIcon;
      default:
        return '';
    }
  };

  const langLinks = Object.keys(languages).map((lang: string, index: number) => (
    <div
      key={index}
      onClick={() => onLangChange(lang)}
      className={applyStyles([
        style['lang-row'],
        'text-h4',
        currentLang === lang ? applyStyles([style['current-lang'], 'text-h4-semibold']) : ''
      ])}
    >
      <img src={getLanguagesFlags(languages[lang])} className={style['flag']} height="20px" width="20px" alt="no flag" />
      <span style={{ marginTop: 2 }}>{languages[lang]}</span>

      {index === Object.keys(languages).length ? <hr /> : null}
    </div>
  ));

  return (
    <div
      id="languages-menu"
      className={applyStyles([style['menu'], show ? style['show'] : style['hide']])}
      onPointerMove={onSwipe}
      onPointerCancel={onCancel}
    >
      <div className={applyStyles([style['title'], 'text-h4-semibold'])}>
        <FormattedMessage id="chooseLanguage" />
      </div>
      {langLinks}
    </div>
  );
};

export default LanguagesMenuMobile;
